import { render } from "./SpinnerComponent.vue?vue&type=template&id=38b6d268&scoped=true"
const script = {}

import "./SpinnerComponent.vue?vue&type=style&index=0&id=38b6d268&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38b6d268"]])

export default __exports__